// import * as dotenv from 'dotenv'
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'bootstrap'
import LocalStorage from '@/utils/localstorage'
import axios from 'axios'
import './scss/app.scss'
import NProgress from 'nprogress'
import authHeader from '@/http/auth.header'
import authHeaderRefresh from '@/http/auth.header.refresh'
import { authService } from '@/http/auth'
import { setupAxiosInterceptor } from '@/http/axios-interceptor'

declare global {
  interface Window {
    roleAccessRefreshPrompted?: boolean
  }
}

// dotenv.config()

// var host = window.location.protocol + '//api.' + window.location.hostname
let host = process.env.VUE_APP_BASE_URL
if (!host) {
  host = 'http://localhost:8082/'
}
LocalStorage.set('base_url', host)

// Axios Setup
axios.defaults.baseURL = host
axios.defaults.headers.common = authHeader()

// Setup route context interceptor
setupAxiosInterceptor(axios)

// Callback untuk ketika role_access data berubah
const handleRoleAccessChange = () => {
  // Hindari multiple popup
  if (window.roleAccessRefreshPrompted) {
    return
  }
  
  window.roleAccessRefreshPrompted = true
  
  // Tampilkan popup confirmation
  const swal = require('sweetalert')
  swal({
    title: 'Permission Updated',
    text: 'Your access permissions have been updated. Would you like to refresh the page?',
    icon: 'info',
    buttons: {
      cancel: {
        text: 'Not Now',
        value: false,
        visible: true,
        className: 'btn-secondary'
      },
      confirm: {
        text: 'Refresh Now',
        value: true,
        visible: true,
        className: 'btn-primary'
      }
    }
  }).then((isConfirmed: boolean) => {
    if (isConfirmed === true) {
      window.location.reload()
    } else {
      // Reset flag jika user memilih tidak refresh
      window.roleAccessRefreshPrompted = false
    }
  })
}

// before a request is made start the nprogress
axios.interceptors.request.use(config => {
  NProgress.start()
  return config
})

const isretry = localStorage.getItem('retry') || 0
// before a response is returned stop nprogress
axios.interceptors.response.use(response => {
  NProgress.done()
  return response
}, function (error) {
  const originalRequest = error.config
  NProgress.done()
  if (error.response.status === 401 && isretry == 0) {
    originalRequest._retry = true
    localStorage.setItem('retry', '1')
    axios.defaults.headers.common = authHeaderRefresh()
    Promise.resolve(authService.refreshAccessToken())
      .then(() => {
        axios.defaults.headers.common = authHeader()
        const access_token = JSON.parse(localStorage.getItem('accessToken') || '{}')
        if (access_token.length > 0) {
          originalRequest.headers.Authorization = 'Bearer ' + access_token
          axios(originalRequest)
          // window.location.reload()
          window.location.href = '/user/bill'
        } else {
          authService.logout()
        }
      }).catch(() => {
        authService.logout()
      })
  } else if (error.response.status == 401) {
    LocalStorage.clearAdmin()
    LocalStorage.clearUser()

    // check if this web is in iframe
    if (window.self !== window.top) {
      window.location.href = '/auth'
    } else {
      window.location.href = '/loginpage'
    }
  }
  return Promise.reject(error)
})

// Start role access auto-update on app load (only if user is logged in)
const initRoleAccessAutoUpdate = () => {
  try {
    const user = LocalStorage.getOne('user')
    const roleAccess = LocalStorage.getOne('role_access')
    
    // Only start if user is logged in and has role_access data
    if (user && roleAccess) {
      authService.startRoleAccessAutoUpdate(handleRoleAccessChange)
    }
  } catch (error) {
    console.error('Error initializing role access auto-update:', error)
  }
}

createApp(App).use(router).mount('#app')

// Start auto-update after app is mounted
initRoleAccessAutoUpdate()
